import 'ng-sortable';
import 'tooltips';
import angular from 'angular';
import rwDashboardErrorCodeModule from './config/errorcode.conf';
import rwDashboardRoutingModule from './rw-dashboard-routing-module';
import rwDashboardWidgetModule from './components/dashboard-widget/dashboard-widget-module';
import retailerFilterModule from './components/retailer-filter/retailer-filter-module';
import RwDashboardsComponent from './components/rw-dashboards-component';
import RwDashboardComponent from './components/rw-dashboard/rw-dashboard-component';
import RwRenderWidgetsComponent from './components/rw-render-widgets/rw-render-widgets-component';
import RwRemoveWidgetComponent from './components/rw-remove-widget/rw-remove-widget-component';
import RwMoveWidgetComponent from './components/rw-move-widget/rw-move-widget-component';
import RwRenderWidgetDirective from './components/rw-render-widget/rw-render-widget-directive';

export default angular
  .module('dashboard', [
    rwDashboardErrorCodeModule.name,
    rwDashboardRoutingModule.name,
    rwDashboardWidgetModule.name,
    retailerFilterModule.name,
    'as.sortable',
    '720kb.tooltips',
  ])
  .component('rwDashboards', new RwDashboardsComponent())
  .component('rwDashboard', new RwDashboardComponent())
  .component('rwRenderWidgets', new RwRenderWidgetsComponent())
  .component('rwRemoveWidget', new RwRemoveWidgetComponent())
  .component('rwMoveWidget', new RwMoveWidgetComponent())
  .directive('rwRenderWidget', RwRenderWidgetDirective);



// WEBPACK FOOTER //
// ./src/modules/dashboard/dashboard-module.js